var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showOops)?_c('oops',{attrs:{"row-type":_vm.rowType}}):_c('item-page',{attrs:{"show-progress":_vm.showProgress,"item-reason":_vm.itemReason,"row-type":_vm.rowType,"item":_vm.item,"content-heading":_vm.contentHeading,"item-obj":_vm.itemReason,"item-name":_vm.itemName,"row-types":_vm.rowTypes,"auth":_vm.auth}})
}
var staticRenderFns = []

export { render, staticRenderFns }